import { useMutation } from "@tanstack/react-query";

import { removeLogo, RemoveLogoPayload } from "../../../services/accounts/remove_logo";
import { accountsKeys } from "./query_keys";

export const useRemoveAccountLogo = () => {
  const mutationKey = accountsKeys.logo();

  return useMutation(async (data: RemoveLogoPayload) => removeLogo(data), { mutationKey });
};
